import {
  generateBindings,
  ObservableValue,
  useObservedValue,
  view,
} from '@esui/core';
import { spread } from '@esui/core/utils/spread.js';
import '@material/mwc-circular-progress-four-color';
import { html } from 'lit';

export const [CircularProgressFourColor] = view(
  'esui-mwc-circular-progress-four-color',
  {
    Props: class {
      indeterminate = false;
      progress: number | ObservableValue<number> = 0;
      closed: boolean | ObservableValue<boolean> = false;
      density = 0;
    },
    mapBuilder: CircularProgressFourColorBuilder => (progress?: number) => {
      if (typeof progress === 'undefined') {
        return CircularProgressFourColorBuilder().indeterminate(true);
      }
      return CircularProgressFourColorBuilder().progress(progress);
    },

    template(props) {
      const progress = useObservedValue(props.progress);
      const closed = useObservedValue(props.closed);
      const { density, indeterminate } = props;

      const computedProps = generateBindings({
        indeterminate,
        progress,
        density,
        closed,
      });

      return html`
        <mwc-circular-progress-four-color ${spread({ ...computedProps })}>
        </mwc-circular-progress-four-color>
      `;
    },
  }
);
